import { render, staticRenderFns } from "./BookingGroupForm.vue?vue&type=template&id=4ed9515f&scoped=true"
import script from "./BookingGroupForm.vue?vue&type=script&lang=js"
export * from "./BookingGroupForm.vue?vue&type=script&lang=js"
import style0 from "./BookingGroupForm.vue?vue&type=style&index=0&id=4ed9515f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed9515f",
  null
  
)

export default component.exports